import { useState } from 'react';

import ImportacaoRemuneracaoVendedores from '../../components/ImportacaoRemuneracaoVendedores/ImportacaoRemuneracaoVendedores';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function RemuneracaoVendedoresImportacao() {
    const [notify, setNotify] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    return (
        <>
            {notify.isActive && <NotifierPopup notify={notify} setNotify={setNotify} />}
            <ImportacaoRemuneracaoVendedores
                setNotifier={(isSuccessful, message) => setNotify({
                    isActive: true,
                    isSuccessful,
                    message
                })}
            />
        </>
    );
}
